import { render } from "./LoadGitModal.vue?vue&type=template&id=35e05eec&scoped=true"
import script from "./LoadGitModal.vue?vue&type=script&lang=js"
export * from "./LoadGitModal.vue?vue&type=script&lang=js"

import "./LoadGitModal.vue?vue&type=style&index=0&id=35e05eec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e05eec"]])

export default __exports__